
export default function PRAProcessController(
  $q,
  $rootScope,
  $scope,

  alerts,
  confirmDialog,
  loaderService,
  ssDialogService,
  userService,

  assetSharedModelService,
  praDataService,
  praSharedModelService,

  approvePRAProcessDialog,
  assignPRAAssetDialog,
  editPraProcessDialog
) {
  const vm = this;

  vm.handleExpandProcess = _handleExpandProcess;
  vm.handleEditProcess = _handleEditProcess;
  vm.handleAssignAssets = _handleAssignAssets;
  vm.handleSubmitProcess = _handleSubmitProcess;
  vm.handleApproveProcess = _handleApproveProcess;
  vm.handleResetProcess = _handleResetProcess;
  vm.isExpanded = false;
  vm.hasData = false;

  _activate();

  /** *************************************************
   * Private Functions
   */

  function _activate() {
    _initResidualRiskLevel();
    _initRiskAppetite();
    _initEventListeners();
    _initPermissions();
  }

  function _initResidualRiskLevel() {
    // vm.process.residualRiskLevelName = _getRiskAppetiteNameById(vm.process.customerRiskAppetiteLevelId);
    // vm.process.residualRiskLevelCssClass = praSharedModelService
    //   .residualRiskLevelClassMappings[vm.process.residualRiskLevel];
  }

  function _initRiskAppetite() {
    if (vm.process.customerRiskAppetiteLevelId) {
      const _riskAppetiteLevel = praSharedModelService.customerRiskAppetiteLevels.find(
        riskAppetiteLevel => riskAppetiteLevel.customerRiskAppetiteLevelID === vm.process.customerRiskAppetiteLevelId
      ).riskAppetiteLevel;
      vm.process.riskAppetiteName = _riskAppetiteLevel.name;
      vm.process.riskAppetiteDisplayName = _riskAppetiteLevel.name.replace(' Risk', '');
      vm.process.riskAppetiteLevelId = _riskAppetiteLevel.riskAppetiteLevelId;
      vm.process.riskAppetiteCssClass = praSharedModelService
        .riskAppetiteClassMappings[vm.process.riskAppetiteLevelId];
    } else {
      vm.process.riskAppetiteName = 'Not Set';
      vm.process.riskAppetiteLevelId = null;
      vm.process.riskAppetiteCssClass = praSharedModelService
        .riskAppetiteClassMappings[vm.process.riskAppetiteLevelId];
    }
  }

  function _initEventListeners() {
    $scope.$on('refreshMainAssessmentProcess', (event, payload) => {
      if (payload.process.assessmentProcessId === vm.process.assessmentProcessId) {
        loadProcess(event, 'refresh', false);
      }
    });
  }

  function _initPermissions() {
    return userService.getUserPermissionSet('admin').then((permissions) => {
      vm.permissions = permissions;
    });
  }
/* eslint-disable */
  function loadProcess($event, action, getNew) {
    loaderService.showViewLoader = true;
    const promises = [
      praDataService.getProcessAssetsByType(vm.process.assessmentProcessId),
      praSharedModelService._initPage(getNew),
    ];

    if (action === 'assign') {
      promises.push(praDataService.getProcessAssignedAssets(vm.process.assessmentProcessId));
    }

    return $q.all(promises).then((getProcessResponse) => {
      try {
        vm.process = getProcessResponse[0].data;
        _initRiskAppetite();
        vm.assetTypes = assetSharedModelService.AssetTypes;
        vm.assetsByType = vm.process.customerAssetTypes;
        if (action === 'edit') {
          _showEditProcessDialog($event);
        } else if (action === 'assign') {
          // vm.process.assessmentCustomerAssets = getProcessResponse[2].data.assessmentCustomerAssets;
          vm.process.assessmentCustomerAssets = getProcessResponse[2].data;
          _showAssignAssetDialog();
        }
        vm.hasData = true;
      } catch (error) {
        console.error(error);
      }
    }).finally(() => {
      loaderService.showViewLoader = false;
    });
  }

  function _handleApproveProcess($event) {
    loaderService.showViewLoader = true;
    praDataService.getAssessment(vm.assessment.assessmentId).then((response) => {
      const _assessment = angular.copy(response.data);
      vm.assessmentLoaded = true;
      // loaderService.showViewLoader = false;
      ssDialogService.dialogs.pra.approvePRAProcessDialog = ssDialogService.alert(
        approvePRAProcessDialog.getOptions($event, {
          _processes: _assessment.assessmentProcesses,
          activeProcess: vm.process,
        })
      );
      return ssDialogService.show(ssDialogService.dialogs.pra.approvePRAProcessDialog);
    });
  }

  function _handleResetProcess() {
    loaderService.showViewLoader = true;
    praDataService.resetAssessmentProcess(vm.process.assessmentProcessId).then(() => {
      alerts.success('The Process has been reset successfully.');
      $rootScope.$broadcast('refreshMainAssessment');
      loaderService.showViewLoader = false;
    });
  }

  function _showEditProcessDialog($event) {
    ssDialogService.dialogs.pra.editProcessDialog = ssDialogService.alert(
      editPraProcessDialog.getOptions($event, {
        customerId: vm.customerId,
        process: vm.process,
        assetsByType: vm.assetsByType,
        assetTypes: vm.assetTypes,
        customerRiskAppetiteLevels: praSharedModelService.customerRiskAppetiteLevels,
        updateCallBack: _handleUpdateCallBack
      })
    );
    ssDialogService.show(ssDialogService.dialogs.pra.editProcessDialog);
  }

  function _showAssignAssetDialog($event) {
    ssDialogService.dialogs.pra.assignAssetDialog = ssDialogService.alert(
      assignPRAAssetDialog.getOptions($event, {
        process: vm.process,
        assetTypes: vm.assetTypes,
        assignedAssets: vm.process.assessmentCustomerAssets
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.pra.assignAssetDialog);
  }

  /** *************************************************
   * Event Handlers
   */

  function _handleUpdateCallBack(process) {
    vm.process.customerRiskAppetiteLevelId = process.customerRiskAppetiteLevelId;
    vm.process.notes = process.notes;
    vm.process.status = process.status;
    vm.process.canApprove = process.canApprove;
    vm.process.dateSubmitted = process.dateSubmitted;
    vm.process.totalEffectiveInherentRisk = process.totalEffectiveInherentRisk;
    vm.process.assetCount = process.assetCount;
    vm.process.residualRisk = process.residualRisk;
    _initRiskAppetite();
    $rootScope.$broadcast('refreshMainAssessmentProcess', { process: vm.process });
  }

  function _handleExpandProcess($event) {
    if (!vm.hasData) {
      loadProcess($event, 'expand');
    }
    vm.isExpanded = !vm.isExpanded;
  }

  function _handleEditProcess($event) {
    loadProcess($event, 'edit');
  }

  function _handleAssignAssets($event) {
    loadProcess($event, 'assign');
  }

  function _handleSubmitProcess($event) {
    ssDialogService.dialogs.pra.submitProcessConfirmDialog = ssDialogService.alert(
      confirmDialog.getOptions($event, {
        dialogTitle: 'Submit Process?',
        message: `Are you sure you want to submit process "${vm.process.name}"?`,
        handleYesClick: _handleConfirmSubmit,
        handleNoClick: _closeDeleteDialog,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.pra.submitProcessConfirmDialog);
  }

  function _closeDeleteDialog() {
    ssDialogService.hide(ssDialogService.dialogs.pra.submitProcessConfirmDialog);
  }

  function _handleConfirmSubmit() {
    loaderService.showViewLoader = true;
    const _processIds = [];
    _processIds.push(vm.process.assessmentProcessId);
    praDataService.submitAssessmentProcesses(_processIds)
      .then(() => {
        loaderService.showViewLoader = false;
        alerts.success(`The process "${vm.process.name}" has successfully been submitted.`);
        $rootScope.$broadcast('refreshMainAssessmentProcess', { process: vm.process });
        _closeDeleteDialog();
      });
  }
}

PRAProcessController.$inject = [
  '$q',
  '$rootScope',
  '$scope',

  'alerts',
  'confirmDialog',
  'loaderService',
  'ssDialogService',
  'userService',

  'assetSharedModelService',
  'praDataService',
  'praSharedModelService',

  'approvePRAProcessDialog',
  'assignPRAAssetDialog',
  'editPraProcessDialog',
];
